<template>
    <div class="clock" :class="{shanghaitech:shanghaitech}">
        <div class="date ecnu">{{ date }} <span v-if="shanghaitech">{{ time }}</span></div>
        <div class="time" v-if="!ecnu && !shanghaitech">{{ time }}</div>
    </div>
</template>

<script>

function zeroPadding(num, digit) {
    var zero = '';
    for (var i = 0; i < digit; i++) {
        zero += '0';
    }
    return (zero + num).slice(-digit);
}

export default {
    name: "digital-clock",
    data() {
        return {
            date: '',
            time: ''
        }
    },
    props: {
        ecnu: {
            type: Boolean, default() {
                return false;
            }
        },
        shanghaitech: {
            type: Boolean, default() {
                return false;
            }
        }
    },
    created() {
        const that = this;
        setInterval(function () {
            that.updateTime();
        }, 1000)
    },
    methods: {
        updateTime() {
            const cd = new Date();
            const week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            this.time = zeroPadding(cd.getHours(), 2) + '时' + zeroPadding(cd.getMinutes(), 2) + "分";
            this.date = zeroPadding(cd.getFullYear(), 4) + '年' + zeroPadding(cd.getMonth() + 1, 2) + '月' + zeroPadding(cd.getDate(), 2) + '日 ' + week[cd.getDay()];

        }
    }
}
</script>

<style scoped lang="less">
.clock {
    font-size: 16px;
    color: #777777;

    .date {
        margin-top: 10px;
        font-weight: bold;
    }

    .time {
        font-size: 16px;
        text-align: right;
        font-weight: bold;
    }

    &.shanghaitech {
        color: #333333;
        font-weight: bold;
        height: auto;

        .date {
            font-size: 16px;
            line-height: 28px;
        }
    }
}


</style>
